import PropTypes from 'prop-types';
import { TableCell, TableSortLabel, Typography } from '@mui/material';

import { SORT_OPTIONS } from 'constants/common';
import { SORTABLE_TABLE_COLUMN_TYPES } from 'constants/components';
import { ArrowFilledDownIcon } from 'assets/icons';

const styles = {
  cell: ({ spacing }, width) => ({
    width,
    border: 'none',
    paddingBlock: 'unset',
    paddingInline: spacing(1),

    '&:first-of-type': {
      paddingLeft: spacing(3),
    },
  }),
  label: ({ palette }) => ({
    gap: 1,
    svg: {
      color: `${palette.common.black} !important`,
      opacity: 1,
    },
  }),
  labelText: ({ palette }) => ({
    color: palette.common.black,
  }),
};

const SortableHeaderCell = ({ cellData: { label, dataKey, align, sortable, width }, isSorted, order, onTableSort }) => {
  const labelContent = (
    <Typography variant="body1" component="span" align={align} sx={styles.labelText}>
      {label}
    </Typography>
  );

  return (
    <TableCell align={align} key={dataKey} sx={(theme) => styles.cell(theme, width)}>
      {sortable ? (
        <TableSortLabel
          active={isSorted}
          direction={isSorted ? order : SORT_OPTIONS.DESC}
          IconComponent={ArrowFilledDownIcon}
          onClick={() => onTableSort(dataKey)}
          sx={styles.label}
        >
          {labelContent}
        </TableSortLabel>
      ) : (
        labelContent
      )}
    </TableCell>
  );
};

SortableHeaderCell.propTypes = {
  cellData: PropTypes.shape({
    label: PropTypes.string,
    dataKey: PropTypes.string.isRequired,
    align: PropTypes.string,
    sortable: PropTypes.bool,
    columnType: PropTypes.oneOf(Object.values(SORTABLE_TABLE_COLUMN_TYPES)).isRequired,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  isSorted: PropTypes.bool.isRequired,
  order: PropTypes.oneOf(Object.values(SORT_OPTIONS)).isRequired,
  onTableSort: PropTypes.func.isRequired,
};

export default SortableHeaderCell;
